@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<div id="video-editing" [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <h1>Video Editing</h1>

    <header>
        {{ 'languages.french' | translate }} {{ 'common.to'| translate }} {{ 'languages.english'| translate }}
    </header>

    <div class="content">

        <section>
            <div class="settings">
                <div>Ecoutez votre vidéo et ajoustez les differents volumes comme vous le souhaitez</div>
                <form [formGroup]="audioForm" (ngSubmit)="complete()">
                    <div class="audio-settings">
                        <div class="audio-setting" (submit)="complete()">
                            @let originalVolumeValue = audioForm.controls['originalVolume'].value;
                            <label for="original-volume">
                                <lucide-icon size="20" [name]=" originalVolumeValue > 0 ? 'volume2' : 'volume-x' "></lucide-icon>
                                Original voices Volume</label>
                            <input formControlName="originalVolume" type="range" step="0.01" id="original-volume"
                                name="original-volume" min="0" max="1">
                            <p class="tips">La voix originale de la video est en français.</p>
                            @if(assetsLoaded){
                            <audio step="0.01" class="audioPlayer" #audioVocal [volume]="originalVolumeValue">
                                <source [src]="vocalsUrl" type="audio/wav">
                            </audio>
                            }
                        </div>
                        <div class="audio-setting">
                            @let translationVolumeValue = audioForm.controls['translationVolume'].value;
                            <label for="translation-volume"><lucide-icon size="20"
                                    [name]="translationVolumeValue > 0 ? 'volume2' : 'volume-x'"></lucide-icon>Translation
                                voices
                                Volume</label>
                            <input formControlName="translationVolume" type="range" step="0.01" id="translation-volume"
                                name="translation-volume" min="0" max="1">
                            <p class="tips">La voix transcrite de la video est en anglais. </p>
                            @if(assetsLoaded){
                            <audio step="0.01" class="audioPlayer" #audioTranslated [volume]="translationVolumeValue">
                                <source [src]="translatedAudioUrl" type="audio/wav">
                            </audio>
                            }

                        </div>
                        <div class="audio-setting">
                            @let soundVolumeValue = audioForm.controls['musicVolume'].value;
                            <label for="music-volume"><lucide-icon size="20" [name]="soundVolumeValue > 0 ? 'volume2' : 'volume-x'"></lucide-icon>Music & Sound
                                Volume</label>
                            <input formControlName="musicVolume" type="range" step="0.01" id="music-volume"
                                name="music-volume" min="0" max="1">
                            <p class="tips">la musique et les sons de votre vidéo.</p>
                            @if(assetsLoaded){
                            <audio step="0.01" class="audioPlayer" #audioMusic
                                [volume]="soundVolumeValue">
                                <source [src]="musicUrl" type="audio/wav">
                            </audio>
                            }

                        </div>
                    </div>
                    <app-button type="submit">finalisation</app-button>
                </form>
            </div>
        </section>

        @if(assetsLoaded){
        <section class="video-player">
            <video #videoPlayer [muted]="true">
                <source [src]="videoCleanUrl" />
            </video>
            <!-- ? dans un premier temps on va laisser les controles du player video -->
            <div class="controls">
                <div class="control-btn" (click)="play()">
                    @if(isPlaying){
                        <lucide-icon size="20" name="pause"></lucide-icon>
                    }@else { 
                        <lucide-icon size="20" name="play"></lucide-icon>
                    }
                </div>
                <div class="control-btn" (click)="stop()">
                    <lucide-icon size="20" name="square"></lucide-icon>
                </div>
                <input class="progress-bar" type="range" name="" id="">
            </div>
        </section>
        } @else {
        <div class="video-player-loading">
            <p>loading ...</p>
        </div>
        }
    </div>

</div>